import { api } from '@/shared/services/baseApiClient';
import { config } from '@/config/config';
import urljoin from 'url-join';
import { EmailTemplateViewModel } from '@/features/settings/models/emailTemplateViewModel';
import { CreateTemplateViewModel } from '@/features/settings/models/request/createTemplateViewModel';
import { UpdateTemplateViewModel } from '@/features/settings/models/request/updateTemplateViewModel';
import { EmailWorkspaceModel } from '@/features/settings/models/response/emailWorkspaceModel';
import { SaveEmailWorkspaceModel } from '@/features/settings/models/request/saveEmailWorkspaceModel';
import { VerifyDomainModel } from '@/workspaces/models/response/verifyDomainModel';

class EmailApiService {
  private version = 'v1';

  public getEmailWorkspace(workspaceId: string): Promise<EmailWorkspaceModel> {
    return api.send('GET', urljoin(config().emailHost, this.version, 'workspaces', workspaceId));
  }

  public saveEmailWorkspace(workspaceId: string, request: SaveEmailWorkspaceModel): Promise<EmailWorkspaceModel> {
    return api.send('PUT', urljoin(config().emailHost, this.version, 'workspaces', workspaceId), request);
  }

  public async verifyDomain(workspaceId: string): Promise<VerifyDomainModel> {
    return await api.send(
      'POST',
      urljoin(config().emailHost, this.version, 'workspaces', workspaceId, 'domain/verify'),
    );
  }

  public getTemplates(workspaceId: string): Promise<EmailTemplateViewModel[]> {
    return api.send('GET', urljoin(config().emailHost, this.version, workspaceId, 'templates'));
  }

  public async getTemplateContent(workspaceId: string, templateId: string): Promise<string> {
    const response: any = await api.send(
      'GET',
      urljoin(config().emailHost, this.version, workspaceId, 'templates', templateId),
    );
    return response.template;
  }

  public createEmailTemplate(workspaceId: string, templateName: string, content: string): Promise<void> {
    const request: CreateTemplateViewModel = { templateName, content };
    return api.send('POST', urljoin(config().emailHost, this.version, workspaceId, 'templates'), request);
  }

  public saveEmailTemplate(
    workspaceId: string,
    templateId: string,
    templateName: string,
    content: string,
  ): Promise<void> {
    const request: UpdateTemplateViewModel = { templateName, content };
    return api.send('PUT', urljoin(config().emailHost, this.version, workspaceId, 'templates', templateId), request);
  }

  public deleteEmailTemplate(workspaceId: string, templateId: string): Promise<void> {
    return api.send('DELETE', urljoin(config().emailHost, this.version, workspaceId, 'templates', templateId));
  }
}

export const emailApi = new EmailApiService();
